module.exports = __webpack_public_path__ + "media/customizations/wildryelife/back-2b6f65fa0b1c1cc8597fb46e5f308213.jpg";